/* TwoMemo live designer — UI init. Drives the ported TMDesigner engine on any
   [data-tmd] section: live preview + controls (garment, per-tee colour/size,
   text, photos, print side), price, and line-item-property capture. */
(function () {
  function initTmd(root) {
    if (root.dataset.tmdBound) return;
    var D = window.TMDesigner;
    if (!D) return false;
    root.dataset.tmdBound = '1';
    try { D.injectCSS(document.documentElement); } catch (e) {}

    var tpl = D.TPL[root.getAttribute('data-tpl')];
    if (!tpl) return true;
    var isCouple = tpl.kind === 'couple';
    var sides = isCouple ? ['a', 'b'] : ['a'];

    // Round-7 item 1: single tees can be bought as a 2-tee bundle (two
    // INDEPENDENT line items, same design, different personalisation; the
    // Buy-X-Get-Y discount prices the pair). Couple sets keep their one-line
    // model. `u2` is the second tee's state, built lazily on first pick.
    var bundleCapable = !isCouple;
    var bundle = 1;
    var u2 = null;
    var u1files = {};   // File objects for Tee 1 photos (for the AJAX dual-add)

    var cfg = D.cfgOfTpl(tpl, 'osd');
    var sizes = { a: 'M', b: 'M' };
    // cfgOfTpl seeds cfg.cu with the template's sample copy. Those samples are
    // for the PREVIEW and the placeholders only — the inputs start empty and
    // `typed` is the single source of truth for validation and order properties,
    // so a real order can never carry "Ananya"/"Taken since 2022".
    var samples = {};
    Object.keys(cfg.cu || {}).forEach(function (k) { samples[k] = cfg.cu[k]; });
    var typed = {};
    function textFor(id) {
      var t = (typed[id] || '').trim();
      return t ? t : (samples[id] || '');
    }
    var $ = function (sel) { return root.querySelector(sel); };
    var stage = $('[data-tmd-stage]');
    var form = $('[data-tmd-form]');

    $('[data-tmd-name]').textContent = tpl.name;
    var descEl = $('[data-tmd-desc]');
    if (descEl) descEl.textContent = tpl.desc || tpl.line || '';
    // Round-8 item 1: clamp the description to 2 lines with a Read-more toggle,
    // shown only when the text actually overflows.
    var descMore = $('[data-tmd-descmore]');
    if (descMore && descEl) {
      descMore.addEventListener('click', function () {
        var open = descEl.classList.toggle('is-open');
        descMore.textContent = open ? 'Read less' : 'Read more';
      });
      (window.requestAnimationFrame || setTimeout)(function () {
        if (!descEl.classList.contains('is-open') && descEl.scrollHeight - descEl.clientHeight > 2) descMore.hidden = false;
      });
    }
    // Eyebrow = kind · template type (review item 9). "Design live" meant nothing
    // to a buyer; the template type (Photo upload / Text only / Ready-made) does.
    var TYPE_LABEL = { photo: 'Photo upload', text: 'Text only', ready: 'Ready-made' };
    var typeLabel = TYPE_LABEL[tpl.type] || '';
    $('[data-tmd-eyebrow]').textContent = (isCouple ? 'Couple set' : 'Single tee') + (typeLabel ? ' · ' + typeLabel : '');

    // ---- Gallery (SPEC §3.4 / review item 12): main image + thumbnails
    // (front / back / flat artwork / model). The main image is the live preview;
    // thumbnails re-render as the buyer types. `cfg.face` stays the real print
    // face (drives the Print-side property); `view` is only what's on screen.
    var artFace = (tpl.faces === 'both') ? 'back' : cfg.face;
    var VIEWS = (tpl.faces === 'both') ? ['front', 'back', 'art', 'fit'] : [cfg.face, 'art', 'fit'];
    var LABEL = { front: 'Front', back: 'Back', art: 'Flat art', fit: 'Model' };
    var view = (D.mainFace ? D.mainFace(cfg) : artFace);
    if (VIEWS.indexOf(view) === -1) view = VIEWS[0];
    var thumbsEl = $('[data-tmd-thumbs]');

    function sceneFor(v) {
      if (v === 'art') return D.scene('art', cfg, { face: artFace });
      if (v === 'fit') return D.scene('fit', cfg);
      return D.scene(isCouple ? 'pair' : 'one', cfg, { face: v });
    }
    function render() {
      if (bundle === 2 && u2) {
        // Two independent single-tee scenes side by side.
        stage.innerHTML = '<div class="tmd__pairwrap">' +
          D.scene('one', cfg, { face: view }) + D.scene('one', u2.cfg, { face: view }) + '</div>';
      } else {
        stage.innerHTML = sceneFor(view);
      }
      if (!thumbsEl) return;
      thumbsEl.querySelectorAll('.tmd__thumb').forEach(function (b) {
        var v = b.getAttribute('data-view');
        var img = b.querySelector('.tmd__thumbimg');
        if (img) img.innerHTML = sceneFor(v);
        b.setAttribute('aria-pressed', v === view ? 'true' : 'false');
      });
    }
    if (thumbsEl) {
      thumbsEl.innerHTML = VIEWS.map(function (v) {
        return '<button type="button" class="tmd__thumb" data-view="' + v + '" aria-pressed="' + (v === view ? 'true' : 'false') + '" aria-label="' + LABEL[v] + ' view">' +
          '<span class="tmd__thumbimg"></span><span class="tmd__thumbcap">' + LABEL[v] + '</span></button>';
      }).join('');
      thumbsEl.querySelectorAll('.tmd__thumb').forEach(function (b) {
        b.addEventListener('click', function () { view = b.getAttribute('data-view'); render(); });
      });
    }

    function money(n) { return '₹' + Math.round(n).toLocaleString('en-IN'); }
    // ---- Variant resolution (one line item per product) ----------------
    // Variant = Garment x Tee 1 colour x Tee 1 size. For couple sets Tee 2's
    // colour/size ride along as line-item properties: the couple variants
    // already carry the pair price, so a second line would double-charge.
    // product.variants in Liquid caps at 250, so pull the full list from the
    // AJAX product JSON instead (these products have 437).
    // NOTE: both Liquid `product.variants` and /products/x.js return at most
    // 250 variants. These products have 437, so garments created late in the
    // matrix (Sweatshirt, Hoodie) are NOT addressable from the theme. Until a
    // Storefront API token is available (variantBySelectedOptions), we guard:
    // if the chosen combination has no variant, add-to-bag is blocked rather
    // than silently ordering the wrong one.
    var VARIANTS = {};                         // "Garment / Colour / Size" -> [id, price, compareAt]
    var idEl = root.querySelector('input[name="id"]');
    var mapEl = root.querySelector('[data-tmd-variantmap]');
    var variantTotal = 0;
    if (mapEl) {
      try {
        var parsed = JSON.parse(mapEl.textContent);
        VARIANTS = parsed.v || {};
        variantTotal = parsed.count || 0;
      } catch (e) { VARIANTS = {}; }
    }

    // Option value ids (uncapped) + the section id, for the Section Rendering
    // fallback that resolves variants past Shopify's 250-variant theme limit.
    var OPTVALS = {};
    var ovEl = root.querySelector('[data-tmd-optionvalues]');
    if (ovEl) { try { OPTVALS = JSON.parse(ovEl.textContent); } catch (e) { OPTVALS = {}; } }
    var sectionId = root.getAttribute('data-section-id');
    var productUrl = root.getAttribute('data-product-url');
    var resolveCache = {};

    // Variant lookup keyed by (garment, colour, size) — generalised so Tee 2 of
    // a bundle can resolve its own variant the same way Tee 1 does.
    function keyOf(garment, colourKey, size) {
      return [D.GARM[garment].name, (D.COL[colourKey] || [])[0], size].join(' / ');
    }
    function lookup(garment, colourKey, size) {
      var k = keyOf(garment, colourKey, size);
      var v = VARIANTS[k] || resolveCache[k];
      return v ? { id: v[0], price: v[1], compare_at_price: v[2] } : null;
    }
    function variantKey() { return keyOf(cfg.garment, cfg.colors.a, sizes.a); }
    function currentVariant() { return lookup(cfg.garment, cfg.colors.a, sizes.a); }

    // Section Rendering API: /products/<handle>?option_values=<ids>&section_id=<id>
    // Shopify re-resolves product.selected_or_first_available_variant server side,
    // which works for ALL variants (Liquid's product.variants caps at 250).
    function resolveViaSectionKey(garment, colourKey, size) {
      var key = keyOf(garment, colourKey, size);
      if (VARIANTS[key] || resolveCache[key]) return Promise.resolve(lookup(garment, colourKey, size));
      if (!productUrl || !sectionId) return Promise.resolve(null);
      var g = D.GARM[garment];
      var ids = [
        (OPTVALS.Garment || {})[g.name],
        (OPTVALS.Colour || {})[(D.COL[colourKey] || [])[0]],
        (OPTVALS.Size || {})[size]
      ];
      if (ids.some(function (i) { return !i; })) return Promise.resolve(null);
      var url = productUrl + '?option_values=' + ids.join(',') + '&section_id=' + sectionId;
      return fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return null;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector('[data-tmd-resolved]');
          if (!el || el.dataset.variantAvailable === 'false') return null;
          var rec = [
            parseInt(el.dataset.variantId, 10),
            parseInt(el.dataset.variantPrice, 10),
            parseInt(el.dataset.variantCompare || '0', 10)
          ];
          if (!rec[0]) return null;
          resolveCache[key] = rec;
          return { id: rec[0], price: rec[1], compare_at_price: rec[2] };
        })
        .catch(function () { return null; });
    }
    function resolveViaSection() { return resolveViaSectionKey(cfg.garment, cfg.colors.a, sizes.a); }

    function syncVariant() {
      var v = currentVariant();
      if (!v) {
        // Not in the first 250 — ask Shopify to resolve it, then re-run.
        resolveViaSection().then(function (rec) { if (rec) applyVariant(); else applyVariant(); });
        return;
      }
      applyVariant();
    }

    function applyVariant() {
      var v = currentVariant();
      var addBtn = $('[data-tmd-add]');
      var note = $('[data-tmd-unavailable]');
      if (!v) {
        // Combination exists in the catalogue but is past Shopify's 250-variant
        // theme limit — block rather than order the wrong thing.
        if (idEl) idEl.removeAttribute('name');
        if (addBtn) { addBtn.disabled = true; }
        if (stickyBtnRef) stickyBtnRef.disabled = true;
        if (note) { note.hidden = false; note.textContent = 'This combination can’t be ordered online yet. Pick another garment or colour.'; }
        return;
      }
      if (idEl) { idEl.setAttribute('name', 'id'); idEl.value = v.id; }
      if (addBtn) addBtn.disabled = false;
      if (stickyBtnRef) stickyBtnRef.disabled = false;
      if (note) note.hidden = true;
      fixedPrice = (v.price / 100).toString();
      fixedCompare = v.compare_at_price && v.compare_at_price > v.price
        ? (v.compare_at_price / 100).toString() : '';
      updatePrice();
      // Re-run now that a variant is resolved: Garment + Tee 1 colour/size are
      // carried by the variant, so drop them as duplicate properties (review
      // item 9c — the Section Rendering path resolves after the first setProps).
      setProps();
    }
    var stickyBtnRef = null;   // assigned once the sticky bar is wired below

    // On a product page these start from the Oversized Tee variant (the base
    // garment) and are re-resolved as the customer picks garment/colour/size.
    var fixedPrice = root.getAttribute('data-price');
    var fixedCompare = root.getAttribute('data-compare');
    function updatePrice() {
      if (fixedPrice) {
        var base = parseFloat(fixedPrice);
        // Bundle of 2 singles: show the pair total (2 × base − ₹299 from the
        // Buy-X-Get-Y), with a Save ₹299 chip. Otherwise the single tee price.
        var isBundle = bundle === 2;
        var show = isBundle ? (2 * base - 299) : base;
        root.querySelectorAll('[data-tmd-price]').forEach(function (n) { n.textContent = money(show); });
        var cmpEl = $('[data-tmd-compare]');
        if (cmpEl) cmpEl.textContent = isBundle ? money(2 * base) : (fixedCompare ? money(parseFloat(fixedCompare)) : '');
        var chip = $('[data-tmd-save]');
        if (chip) {
          var diff = isBundle ? 299 : (fixedCompare ? Math.round(parseFloat(fixedCompare) - base) : 0);
          chip.hidden = diff <= 0;
          chip.textContent = diff > 0 ? 'Save ' + money(diff) : '';
        }
        var unitEl = $('[data-tmd-unit]');
        if (unitEl && !isCouple) unitEl.textContent = isBundle ? 'for 2 tees' : 'per tee';
        return;
      }
      $('[data-tmd-price]').textContent = money(D.tplPrice(tpl, cfg.garment));
      var cmp = D.tplCompare ? D.tplCompare(tpl, cfg.garment) : null;
      $('[data-tmd-compare]').textContent = cmp ? money(cmp) : '';
    }

    var gEl = $('[data-tmd-garments]');
    gEl.innerHTML = D.GARM_KEYS.map(function (k) {
      var g = D.GARM[k];
      var d = g.add === 0 ? 'Included' : (g.add > 0 ? '+₹' + g.add : '−₹' + Math.abs(g.add)) + ' / tee';
      return '<button type="button" class="tmd__gopt' + (k === cfg.garment ? ' is-on' : '') + '" data-g="' + k + '"><b>' + g.short + '</b><em>' + d + '</em></button>';
    }).join('');
    gEl.querySelectorAll('.tmd__gopt').forEach(function (b) {
      b.addEventListener('click', function () {
        cfg.garment = b.getAttribute('data-g');
        gEl.querySelectorAll('.tmd__gopt').forEach(function (o) { o.classList.toggle('is-on', o === b); });
        sides.forEach(function (sd) {
          var allowed = D.GARM[cfg.garment].colors;
          if (allowed.indexOf(cfg.colors[sd]) === -1) cfg.colors[sd] = allowed[0];
        });
        buildTees(); render(); updatePrice(); setProps(); syncVariant();
      });
    });

    var teesEl = $('[data-tmd-tees]');
    function buildTees() {
      var g = D.GARM[cfg.garment];
      teesEl.innerHTML = sides.map(function (sd, i) {
        var label = isCouple ? ('Tee ' + (i + 1)) : 'Your tee';
        var sw = g.colors.map(function (ck) {
          var hex = (g.tint && g.tint[ck]) || D.COL[ck][1];
          return '<button type="button" class="tmd__sw' + (ck === cfg.colors[sd] ? ' is-on' : '') + '" title="' + D.COL[ck][0] + '" data-side="' + sd + '" data-col="' + ck + '" style="--sw:' + hex + '"></button>';
        }).join('');
        var sz = g.sizes.map(function (z) {
          return '<button type="button" class="tmd__sz' + (z === sizes[sd] ? ' is-on' : '') + '" data-side="' + sd + '" data-size="' + z + '">' + z + '</button>';
        }).join('');
        return '<div class="tmd__tee"><div class="tmd__teeh">' + label + '</div>' +
          '<div class="tmd__sublabel">Colour</div><div class="tmd__sws">' + sw + '</div>' +
          '<div class="tmd__sublabel">Size</div><div class="tmd__szs">' + sz + '</div></div>';
      }).join('');
      teesEl.querySelectorAll('.tmd__sw').forEach(function (b) {
        b.addEventListener('click', function () {
          var sd = b.getAttribute('data-side'); cfg.colors[sd] = b.getAttribute('data-col');
          teesEl.querySelectorAll('.tmd__sw[data-side="' + sd + '"]').forEach(function (o) { o.classList.toggle('is-on', o === b); });
          render(); setProps();
          if (sd === 'a') syncVariant();   // Tee 1 drives the variant
        });
      });
      teesEl.querySelectorAll('.tmd__sz').forEach(function (b) {
        b.addEventListener('click', function () {
          var sd = b.getAttribute('data-side'); sizes[sd] = b.getAttribute('data-size');
          teesEl.querySelectorAll('.tmd__sz[data-side="' + sd + '"]').forEach(function (o) { o.classList.toggle('is-on', o === b); });
          setProps();
          if (sd === 'a') syncVariant();   // Tee 1 drives the variant
        });
      });
    }

    var fb = $('[data-tmd-fieldsblock]'), fEl = $('[data-tmd-fields]');
    if (tpl.fields && tpl.fields.length) {
      fb.hidden = false;
      fEl.innerHTML = tpl.fields.map(function (f) {
        var cls = 'tmd__field' + (f.wide ? ' tmd__field--wide' : '');
        var ph = (f.ph || (f.sample ? 'e.g. ' + f.sample : '')).replace(/"/g, '&quot;');
        // value is intentionally empty — the sample lives in the placeholder.
        return '<label class="' + cls + '"><span>' + f.label + (f.req ? ' *' : '') + '</span>' +
          '<input type="text" data-field="' + f.id + '" maxlength="' + (f.max || 40) + '" value="" placeholder="' + ph + '"' + (f.req ? ' aria-required="true"' : '') + '></label>';
      }).join('');
      fEl.querySelectorAll('input[data-field]').forEach(function (inp) {
        inp.addEventListener('input', function () {
          var id = inp.getAttribute('data-field');
          typed[id] = inp.value;
          cfg.cu[id] = textFor(id);   // preview falls back to the sample while empty
          render(); setProps();
        });
      });
    }

    var pb = $('[data-tmd-photosblock]'), pEl = $('[data-tmd-photos]');
    if (tpl.photos && tpl.photos.length) {
      pb.hidden = false;
      // Upload tiles per the prototype: dashed box, "+ Upload · Photo n",
      // thumbnail once chosen. The native input is visually hidden inside.
      pEl.innerHTML = tpl.photos.map(function (p) {
        var teeLabel = isCouple ? (' · Tee ' + (p.tee === 'a' ? '1' : '2')) : '';
        return '<label class="tmd__photo" data-tile="' + p.id + '">' +
          '<span class="tmd__photo-plus" aria-hidden="true">+</span>' +
          '<span class="tmd__photo-label">Upload<small>' + p.label + teeLabel + '</small></span>' +
          '<img class="tmd__photo-thumb" alt="" hidden>' +
          '<input type="file" accept="image/png,image/jpeg" data-photo="' + p.id + '" name="properties[Photo ' + p.id + ']">' +
          '</label>';
      }).join('');
      pEl.querySelectorAll('input[data-photo]').forEach(function (inp) {
        inp.addEventListener('change', function () {
          var id = inp.getAttribute('data-photo');
          var tile = inp.closest('.tmd__photo');
          var thumb = tile && tile.querySelector('.tmd__photo-thumb');
          var file = inp.files && inp.files[0];
          if (!file) {
            cfg.ph[id] = null; u1files[id] = null;
            if (tile) tile.classList.remove('has-file');
            if (thumb) { thumb.hidden = true; thumb.removeAttribute('src'); }
            render(); photoCount(); return;
          }
          u1files[id] = file;
          if (tile) { tile.classList.add('has-file'); tile.classList.remove('is-error'); }
          var rd = new FileReader();
          rd.onload = function () {
            cfg.ph[id] = rd.result;
            if (thumb) { thumb.src = rd.result; thumb.hidden = false; }
            render();
          };
          rd.readAsDataURL(file);
          photoCount();
        });
      });
    }

    // ---- Round-7 item 1: 2-tee bundle (single tees) --------------------
    function textFor2(id) { var t = (u2.typed[id] || '').trim(); return t ? t : (samples[id] || ''); }

    function buildTee2() {
      var el = $('[data-tmd-tees2]'); if (!el || !u2) return;
      var g = D.GARM[cfg.garment];
      if (g.colors.indexOf(u2.cfg.colors.a) === -1) u2.cfg.colors.a = g.colors[0];
      if (g.sizes.indexOf(u2.size) === -1) u2.size = g.sizes[0];
      var sw = g.colors.map(function (ck) {
        var hex = (g.tint && g.tint[ck]) || D.COL[ck][1];
        return '<button type="button" class="tmd__sw' + (ck === u2.cfg.colors.a ? ' is-on' : '') + '" title="' + D.COL[ck][0] + '" data-side="b" data-col="' + ck + '" style="--sw:' + hex + '"></button>';
      }).join('');
      var sz = g.sizes.map(function (z) {
        return '<button type="button" class="tmd__sz' + (z === u2.size ? ' is-on' : '') + '" data-side="b" data-size="' + z + '">' + z + '</button>';
      }).join('');
      el.innerHTML = '<div class="tmd__tee"><div class="tmd__teeh">Tee 2</div>' +
        '<div class="tmd__sublabel">Colour</div><div class="tmd__sws">' + sw + '</div>' +
        '<div class="tmd__sublabel">Size</div><div class="tmd__szs">' + sz + '</div></div>';
      el.querySelectorAll('.tmd__sw').forEach(function (b) {
        b.addEventListener('click', function () {
          u2.cfg.colors.a = b.getAttribute('data-col');
          el.querySelectorAll('.tmd__sw').forEach(function (o) { o.classList.toggle('is-on', o === b); });
          render();
        });
      });
      el.querySelectorAll('.tmd__sz').forEach(function (b) {
        b.addEventListener('click', function () {
          u2.size = b.getAttribute('data-size');
          el.querySelectorAll('.tmd__sz').forEach(function (o) { o.classList.toggle('is-on', o === b); });
        });
      });
    }
    function buildFields2() {
      var el = $('[data-tmd-fields2]'); if (!el) return;
      if (!(tpl.fields && tpl.fields.length)) { el.innerHTML = ''; return; }
      el.innerHTML = tpl.fields.map(function (f) {
        var cls = 'tmd__field' + (f.wide ? ' tmd__field--wide' : '');
        var ph = (f.ph || (f.sample ? 'e.g. ' + f.sample : '')).replace(/"/g, '&quot;');
        return '<label class="' + cls + '"><span>' + f.label + (f.req ? ' *' : '') + '</span>' +
          '<input type="text" data-field2="' + f.id + '" maxlength="' + (f.max || 40) + '" value="" placeholder="' + ph + '"' + (f.req ? ' aria-required="true"' : '') + '></label>';
      }).join('');
      el.querySelectorAll('input[data-field2]').forEach(function (inp) {
        inp.addEventListener('input', function () {
          var id = inp.getAttribute('data-field2');
          u2.typed[id] = inp.value; u2.cfg.cu[id] = textFor2(id);
          if (inp.value.trim()) inp.classList.remove('is-error');
          render();
        });
      });
    }
    function photoCount2() {
      var el = $('[data-tmd-photocount2]'); if (!el) return;
      var inputs = root.querySelectorAll('[data-photo2]');
      var filled = [].filter.call(inputs, function (i) { return i.files && i.files.length; }).length;
      el.textContent = filled + ' of ' + inputs.length + ' added';
    }
    function buildPhotos2() {
      var el = $('[data-tmd-photos2]'); if (!el) return;
      if (!(tpl.photos && tpl.photos.length)) { el.innerHTML = ''; return; }
      el.innerHTML = tpl.photos.map(function (p) {
        return '<label class="tmd__photo" data-tile2="' + p.id + '">' +
          '<span class="tmd__photo-plus" aria-hidden="true">+</span>' +
          '<span class="tmd__photo-label">Upload<small>' + p.label + '</small></span>' +
          '<img class="tmd__photo-thumb" alt="" hidden>' +
          '<input type="file" accept="image/png,image/jpeg" data-photo2="' + p.id + '"></label>';
      }).join('');
      el.querySelectorAll('input[data-photo2]').forEach(function (inp) {
        inp.addEventListener('change', function () {
          var id = inp.getAttribute('data-photo2');
          var tile = inp.closest('.tmd__photo');
          var thumb = tile && tile.querySelector('.tmd__photo-thumb');
          var file = inp.files && inp.files[0];
          if (!file) {
            u2.cfg.ph[id] = null; u2.files[id] = null;
            if (tile) tile.classList.remove('has-file');
            if (thumb) { thumb.hidden = true; thumb.removeAttribute('src'); }
            render(); photoCount2(); return;
          }
          u2.files[id] = file;
          if (tile) { tile.classList.add('has-file'); tile.classList.remove('is-error'); }
          var rd = new FileReader();
          rd.onload = function () { u2.cfg.ph[id] = rd.result; if (thumb) { thumb.src = rd.result; thumb.hidden = false; } render(); };
          rd.readAsDataURL(file);
          photoCount2();
        });
      });
    }

    var bundleEl = $('[data-tmd-bundle]');
    function setBundle(n) {
      bundle = n;
      if (bundleEl) bundleEl.querySelectorAll('.tmd__bundleopt').forEach(function (b) {
        var on = b.getAttribute('data-bundle') === String(n);
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (n === 2 && !u2) {
        u2 = { cfg: D.cfgOfTpl(tpl, 'osd'), typed: {}, size: 'M', files: {} };
        buildTee2(); buildFields2(); buildPhotos2(); photoCount2();
      }
      var u2block = $('[data-tmd-unit2]'), tees2 = $('[data-tmd-tees2]');
      if (u2block) u2block.hidden = n !== 2;
      if (tees2) tees2.hidden = n !== 2;
      var qtyRow = root.querySelector('.tmd__qtyrow');
      if (qtyRow) qtyRow.style.display = n === 2 ? 'none' : '';
      updatePrice(); render();
    }
    if (bundleEl) bundleEl.querySelectorAll('.tmd__bundleopt').forEach(function (b) {
      b.addEventListener('click', function () { setBundle(parseInt(b.getAttribute('data-bundle'), 10)); });
    });

    // Item 2: desktop "Start: add your photos" scrolls to step 1 and focuses it.
    var startBtn = $('[data-tmd-start]');
    if (startBtn) startBtn.addEventListener('click', function () {
      var s1 = root.querySelector('[data-tmd-step="1"]');
      if (s1) {
        s1.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var first = root.querySelector('[data-photo], [data-field]');
        if (first) setTimeout(function () { first.focus(); }, 320);
      }
    });

    function setProps() {
      form.querySelectorAll('[data-tmd-dyn]').forEach(function (n) { n.remove(); });
      var add = function (name, val) {
        var i = document.createElement('input'); i.type = 'hidden';
        i.name = 'properties[' + name + ']'; i.value = val;
        i.setAttribute('data-tmd-dyn', '1'); form.appendChild(i);
      };
      add('Design name', tpl.name);
      // Garment + Tee 1 colour/size are carried by the variant itself; only add
      // them as properties when no variant matched (preview-only pages).
      var onVariant = !!currentVariant();
      sides.forEach(function (sd, i) {
        if (onVariant && sd === 'a') return;
        // Singles use "Colour"/"Size"; couples prefix each tee (review item 9).
        var cLabel = isCouple ? ('Tee ' + (i + 1) + ' colour') : 'Colour';
        var sLabel = isCouple ? ('Tee ' + (i + 1) + ' size') : 'Size';
        add(cLabel, D.COL[cfg.colors[sd]][0]);
        add(sLabel, sizes[sd]);
      });
      if (!onVariant) add('Garment', D.GARM[cfg.garment].name);
      // only what the buyer actually typed ever reaches the order
      (tpl.fields || []).forEach(function (f) {
        var v = (typed[f.id] || '').trim();
        if (v) add(f.label, v);
      });
      if (tpl.faces === 'both') add('Print', 'Front + back');
      else add('Print side', cfg.face.charAt(0).toUpperCase() + cfg.face.slice(1));
    }

    // ---- SPEC §3.4: two-step flow, sticky mobile bar, quantity ----
    var step = 1;
    var sticky = $('[data-tmd-sticky]');
    var stickyBtn = $('[data-tmd-stickybtn]');
    stickyBtnRef = stickyBtn;
    var hasStep2 = !!root.querySelector('[data-tmd-step="2"]');

    // Step 1 is complete when every required text field is TYPED and every
    // photo slot of a photo template has a file (SPEC §3.4: photo slots block
    // the step exactly like required fields).
    function missingRequired() {
      return (tpl.fields || []).filter(function (f) { return f.req && !(typed[f.id] || '').trim(); });
    }
    function missingPhotos() {
      return [].filter.call(root.querySelectorAll('[data-photo]'), function (i) {
        return !(i.files && i.files.length);
      });
    }

    function toast(msg) {
      var t = document.createElement('div');
      t.className = 'tmd__toast'; t.setAttribute('role', 'status'); t.textContent = msg;
      document.body.appendChild(t);
      setTimeout(function () { t.remove(); }, 3200);
    }

    function showStep(n) {
      if (!hasStep2) return;
      step = n;
      root.querySelectorAll('[data-tmd-step]').forEach(function (p) {
        p.hidden = p.getAttribute('data-tmd-step') !== String(n);
      });
      root.querySelectorAll('[data-tmd-goto]').forEach(function (b) {
        b.classList.toggle('is-on', b.getAttribute('data-tmd-goto') === String(n));
      });
      if (stickyBtn) stickyBtn.textContent = n === 1 ? 'Next: size and colour →' : 'Add to bag';
      var note = $('[data-tmd-stickynote]');
      if (note) note.textContent = 'Step ' + n + ' of 2';
      // in-flow bar mirrors the stepper so Add to bag is unreachable in step 1
      var barNext = $('[data-tmd-barnext]');
      var addBtn = $('[data-tmd-add]');
      if (barNext) barNext.hidden = n !== 1;
      if (addBtn) addBtn.hidden = n !== 2;
    }

    function gotoStep2() {
      var bad = missingRequired();
      var badPhotos = missingPhotos();
      // Tee 2 (bundle) blocks the step the same way as Tee 1.
      var bad2 = [], badPhotos2 = [];
      if (bundle === 2 && u2) {
        bad2 = (tpl.fields || []).filter(function (f) { return f.req && !(u2.typed[f.id] || '').trim(); });
        badPhotos2 = [].filter.call(root.querySelectorAll('[data-photo2]'), function (i) { return !(i.files && i.files.length); });
      }
      var total = bad.length + badPhotos.length + bad2.length + badPhotos2.length;
      if (total) {
        root.querySelectorAll('[data-field]').forEach(function (i) {
          i.classList.toggle('is-error', bad.some(function (f) { return f.id === i.getAttribute('data-field'); }));
        });
        root.querySelectorAll('[data-photo]').forEach(function (i) {
          var tile = i.closest('.tmd__photo');
          if (tile) tile.classList.toggle('is-error', badPhotos.indexOf(i) > -1);
        });
        root.querySelectorAll('[data-field2]').forEach(function (i) {
          i.classList.toggle('is-error', bad2.some(function (f) { return f.id === i.getAttribute('data-field2'); }));
        });
        root.querySelectorAll('[data-photo2]').forEach(function (i) {
          var tile = i.closest('.tmd__photo');
          if (tile) tile.classList.toggle('is-error', badPhotos2.indexOf(i) > -1);
        });
        var first = root.querySelector('[data-field].is-error, .tmd__photo.is-error, [data-field2].is-error, [data-tile2].is-error');
        if (first) {
          var focusable = first.matches('[data-field], [data-field2]') ? first : first.querySelector('input');
          if (focusable) focusable.focus();
          first.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
        toast(total + (total === 1 ? ' thing to finish on this step.' : ' things to finish on this step.'));
        return;
      }
      showStep(2);
    }

    var nextBtn = $('[data-tmd-next]');
    if (nextBtn) nextBtn.addEventListener('click', gotoStep2);
    var barNextBtn = $('[data-tmd-barnext]');
    if (barNextBtn) barNextBtn.addEventListener('click', gotoStep2);
    root.querySelectorAll('[data-tmd-goto]').forEach(function (b) {
      b.addEventListener('click', function () {
        parseInt(b.getAttribute('data-tmd-goto'), 10) === 2 ? gotoStep2() : showStep(1);
      });
    });
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (step === 1) { gotoStep2(); }
        else { var add = $('[data-tmd-add]'); if (add) add.click(); }
      });
    }
    if (sticky) { sticky.hidden = false; document.body.classList.add('tmd-has-sticky'); }

    var qtyInput = $('[data-tmd-qtyinput]');
    root.querySelectorAll('[data-tmd-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-tmd-qty'), 10));
      });
    });

    function photoCount() {
      var el = $('[data-tmd-photocount]'); if (!el) return;
      var inputs = root.querySelectorAll('[data-photo]');
      var filled = [].filter.call(inputs, function (i) { return i.files && i.files.length; }).length;
      el.textContent = filled + ' of ' + inputs.length + ' added';
    }
    root.addEventListener('change', photoCount);
    root.addEventListener('input', function (e) {
      var t = e.target;
      if (t && t.hasAttribute && t.hasAttribute('data-field') && t.value.trim()) t.classList.remove('is-error');
    });

    // Promise block ETA (review item 8): "Order today, get it by <d1> to <d2>",
    // computed by adding working days (design 3–4 + transit 3–7, Sat/Sun skipped).
    function addWorkingDays(from, n) {
      var d = new Date(from.getTime()); var added = 0;
      while (added < n) { d.setDate(d.getDate() + 1); var wd = d.getDay(); if (wd !== 0 && wd !== 6) added++; }
      return d;
    }
    function setEta() {
      var el = root.querySelector('[data-tmd-eta]'); if (!el) return;
      var now = new Date();
      var lo = addWorkingDays(now, 6), hi = addWorkingDays(now, 11);
      var opt = { day: 'numeric', month: 'short' };
      var f = function (d) { return d.toLocaleDateString('en-IN', opt); };
      el.textContent = 'Order today, get it by ' + f(lo) + ' to ' + f(hi);
    }
    setEta();

    buildTees(); render(); updatePrice(); setProps(); photoCount(); syncVariant();
    if (hasStep2) showStep(1);

    // Round-8 item 3: the error styling must appear ONLY after a failed "Next",
    // never on load. Couple templates were reported initialising with every
    // photo tile in the error state; guarantee a clean initial state by stripping
    // any is-error left on tiles/fields once the whole UI is built.
    root.querySelectorAll('.is-error').forEach(function (n) { n.classList.remove('is-error'); });

    // --- rasterize one artwork SVG (.print) to a PNG Blob (defensive) ---
    function svgToPng(svgEl) {
      return new Promise(function (res) {
        try {
          var xml = new XMLSerializer().serializeToString(svgEl);
          var uri = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(xml)));
          var img = new Image();
          var done = false;
          var t = setTimeout(function () { if (!done) { done = true; res(null); } }, 2500);
          img.onload = function () {
            if (done) return; done = true; clearTimeout(t);
            try {
              var cv = document.createElement('canvas'); cv.width = 900; cv.height = 1200;
              var cx = cv.getContext('2d'); cx.fillStyle = '#ffffff'; cx.fillRect(0, 0, cv.width, cv.height);
              cx.drawImage(img, 0, 0, cv.width, cv.height);
              cv.toBlob(function (b) { res(b); }, 'image/png');
            } catch (e) { res(null); }
          };
          img.onerror = function () { if (!done) { done = true; clearTimeout(t); res(null); } };
          img.src = uri;
        } catch (e) { res(null); }
      });
    }

    // Attach a proof PNG per artwork currently in the preview, as line-item file properties.
    function generateProofs() {
      var prints = stage.querySelectorAll('.print');
      if (!prints.length) return Promise.resolve();
      var jobs = [].map.call(prints, function (sv, i) {
        return svgToPng(sv).then(function (blob) {
          if (!blob) return;
          // Private property (leading underscore): hidden from the customer in
          // cart + checkout, used by the studio and as the bag thumbnail (item 11).
          var name = isCouple ? ('_preview tee ' + (i + 1)) : '_preview';
          var file = new File([blob], (tpl.id + '-proof-' + (i + 1) + '.png'), { type: 'image/png' });
          var input = document.createElement('input');
          input.type = 'file'; input.name = 'properties[' + name + ']';
          input.setAttribute('data-tmd-proofinput', '1');
          var dt = new DataTransfer(); dt.items.add(file); input.files = dt.files;
          form.appendChild(input);
        });
      });
      return Promise.all(jobs);
    }

    // Rasterize ONE unit's artwork to a proof PNG (independent of the stage, so
    // Tee 2 gets its own proof even when the stage shows the pair).
    function proofForUnit(ucfg) {
      var tmp = document.createElement('div');
      tmp.innerHTML = D.scene('one', ucfg, { face: artFace });
      var print = tmp.querySelector('.print');
      return print ? svgToPng(print) : Promise.resolve(null);
    }

    // Build the /cart/add FormData for one bundle tee (variant carries garment/
    // colour/size; typed fields, print side, photos and the proof are properties).
    function unitForm(ucfg, utyped, ufiles, variantId, proofBlob) {
      var fd = new FormData();
      fd.append('id', String(variantId));
      fd.append('quantity', '1');
      fd.append('properties[_design]', tpl.id);
      fd.append('properties[Design name]', tpl.name);
      (tpl.fields || []).forEach(function (f) {
        var v = (utyped[f.id] || '').trim();
        if (v) fd.append('properties[' + f.label + ']', v);
      });
      if (tpl.faces === 'both') fd.append('properties[Print]', 'Front + back');
      else fd.append('properties[Print side]', cfg.face.charAt(0).toUpperCase() + cfg.face.slice(1));
      Object.keys(ufiles || {}).forEach(function (pid) {
        if (ufiles[pid]) fd.append('properties[Photo ' + pid + ']', ufiles[pid], ufiles[pid].name);
      });
      if (proofBlob) fd.append('properties[_preview]', new File([proofBlob], tpl.id + '-proof.png', { type: 'image/png' }));
      return fd;
    }

    var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    function cartAdd(fd) {
      var addUrl = form.action; if (!/\.js(\?|$)/.test(addUrl)) addUrl += '.js';
      return fetch(addUrl, { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then(function (r) { return { ok: r.ok, status: r.status }; });
    }

    function submitBundle() {
      var m1 = (tpl.fields || []).filter(function (f) { return f.req && !(typed[f.id] || '').trim(); });
      var m2 = (tpl.fields || []).filter(function (f) { return f.req && !(u2.typed[f.id] || '').trim(); });
      if (m1.length || m2.length) { toast('Finish both tees before adding to the bag.'); showStep(1); return; }

      submitting = true;
      var addBtn = $('[data-tmd-add]'); if (addBtn) addBtn.disabled = true;
      function fail(msg) { submitting = false; if (addBtn) addBtn.disabled = false; toast(msg); }

      Promise.all([
        resolveViaSectionKey(cfg.garment, cfg.colors.a, sizes.a),
        resolveViaSectionKey(cfg.garment, u2.cfg.colors.a, u2.size)
      ]).then(function (vs) {
        if (!vs[0] || !vs[0].id) throw new Error('tee1-variant');
        if (!vs[1] || !vs[1].id) throw new Error('tee2-variant');
        return Promise.all([proofForUnit(cfg), proofForUnit(u2.cfg)]).then(function (proofs) {
          var fd1 = unitForm(cfg, typed, u1files, vs[0].id, proofs[0]);
          var fd2 = unitForm(u2.cfg, u2.typed, u2.files, vs[1].id, proofs[1]);
          // Strictly sequential: the second add only starts after the first
          // returns, and each response is checked (fetch does NOT reject on a
          // 4xx/5xx, so .ok must be tested explicitly).
          return cartAdd(fd1).then(function (r1) {
            if (!r1.ok) throw new Error('add1');
            return cartAdd(fd2);
          }).then(function (r2) {
            if (!r2.ok) throw new Error('add2');
            // Only redirect once BOTH tees are really in the cart.
            return fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
          }).then(function (cart) {
            if (cart && cart.item_count >= 2) { window.location.href = rootUrl + 'cart'; }
            else { throw new Error('cart-count'); }
          });
        });
      }).catch(function (err) {
        var m = (err && err.message) || '';
        if (m === 'tee2-variant') fail('Pick a size and colour for Tee 2, then try again.');
        else if (m === 'tee1-variant') fail('Pick a size and colour for Tee 1, then try again.');
        else if (m === 'add2') fail('Couldn’t add the second tee — please try again.');
        else fail('Couldn’t add to the bag — please try again.');
      });
    }

    var submitting = false;
    form.addEventListener('submit', function (e) {
      if (submitting) return; // proofs ready — allow native submit
      e.preventDefault();
      // Bundle of 2 single tees → two independent line items via AJAX.
      if (bundle === 2 && u2 && !isCouple) { submitBundle(); return; }
      if (!form.querySelector('input[name="id"]')) { alert('This design needs a product configured before it can be added to the bag.'); return; }
      var bad = (tpl.fields || []).filter(function (f) { return f.req && !(cfg.cu[f.id] || '').trim(); });
      if (bad.length) { alert('Please fill: ' + bad.map(function (f) { return f.label; }).join(', ')); return; }
      // Generate the proof image(s), then submit natively (proofs ride along in FormData).
      form.querySelectorAll('[data-tmd-proofinput]').forEach(function (n) { n.remove(); });
      generateProofs().then(function () { submitting = true; form.submit(); })
        .catch(function () { submitting = true; form.submit(); });
    });
    return true;
  }

  function boot() {
    var roots = document.querySelectorAll('[data-tmd]');
    if (!roots.length) return;
    if (!window.TMDesigner) { setTimeout(boot, 60); return; }
    roots.forEach(initTmd);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
